import axios from "axios";
// import { Message } from "element-ui";
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  // timeout: 5000 // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    if (localStorage.getItem("token")) {
      config.headers["Authorization"] =
        "Bearer" + " " + localStorage.getItem("token");
    }
    return config;
  },
  (error) => {
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    // console.log(response);
    const res = response.data;
    return res;
    // if the custom code is not 20000, it is judged as an error.
    // if (res.code !== 1000) {
    //   Message({
    //     message: res.msg || "Error",
    //     type: "error",
    //     duration: 5 * 1000,
    //   });
    //   return Promise.reject(new Error(res.msg || "Error"));
    // } else {
    //   return res;
    // }
  },
  (error) => {
    // console.log("err" + error);
    // Message({
    //   message: error.message,
    //   type: "error",
    //   duration: 5 * 1000,
    // });
   
    return Promise.reject(error);
    
  }
);

export default service;
